<template>
  <div class="container page1">
    <div class="title">{{ $t('title') }}</div>
    <img src="../../assets/images/main/line.png"
         class="line" />
    <div class="content">
      <div class="item">
        <span class="text">{{ $t('top-title') }}</span>
        {{ $t('top-content') }}
      </div>
      <!-- <div class="item">
        <span class="text">{{ $t('bottom-title') }}</span>
        {{ $t('bottom-content') }}
      </div> -->
    </div>

    <div class="detail"
         v-show="show && left"
         @click="show = false">
      <div class="detail-content">
        <div class="detail-content--title">{{ detail.title }}</div>
        <div class="detail-content--line right"></div>
        <div class="detail-content--text">{{ detail.content }}</div>
      </div>
      <transition name="left-slide">
        <img :src="detail.img"
             v-if="show"
             style="flex: 1" />
      </transition>
    </div>
    <div class="detail"
         v-show="show && !left"
         @click="show = false">
      <transition name="right-slide">
        <img :src="detail.img"
             v-if="show"
             style="flex: 1" />
      </transition>
      <div class="detail-content">
        <div class="detail-content--title">{{ detail.title }}</div>
        <div class="detail-content--line left"></div>
        <div class="detail-content--text">{{ detail.content }}</div>
      </div>
    </div>

    <div class="images"
         v-if="!show">
      <div class="images-left">
        <div class="images-left--top"
             @mouseenter="show1 = true"
             @mouseleave="show1 = false"
             @click="showDetail(1)">
          <transition name="bottom-slide-up">
            <div class="bg-show"
                 style="bottom: 4px;"
                 v-show="show1">
              <span v-show="show1">{{ $t('small-title-1') }}</span>
            </div>
          </transition>
          <transition name="bottom-slide-down">
            <div class="bg bg-show"
                 style="bottom: 4px;"
                 v-show="!show1"></div>
          </transition>
          <img src="../../assets/images/page1/img1.png" />
        </div>
        <div class="images-left--bottom">
          <div style="position: relative; display: inline-block"
               @mouseenter="show2 = true"
               @mouseleave="show2 = false"
               @click="showDetail(5)">
            <transition name="bottom-slide-up">
              <div class="bg-show"
                   style="bottom: 4px;right: 4px;"
                   v-show="show2">
                <span v-show="show2">{{ $t('small-title-5') }}</span>
              </div>
            </transition>
            <transition name="bottom-slide-down">
              <div class="bg bg-show"
                   style="bottom: 4px;right: 4px;"
                   v-show="!show2"></div>
            </transition>
            <img src="../../assets/images/page1/img5.png" />
          </div>
          <div style="position: relative; display: inline-block"
               @mouseenter="show3 = true"
               @mouseleave="show3 = false"
               @click="showDetail(6)">
            <transition name="bottom-slide-up">
              <div class="bg-show"
                   style="bottom: 4px;right: 4px;"
                   v-show="show3">
                <span v-show="show3"
                      style="font-size: 12px;">{{ $t('small-title-6') }}</span>
              </div>
            </transition>
            <transition name="bottom-slide-down">
              <div class="bg bg-show"
                   style="bottom: 4px;right: 4px;"
                   v-show="!show3"></div>
            </transition>
            <img src="../../assets/images/page1/img6.png" />
          </div>
        </div>
      </div>
      <div style="position: relative; display: inline-block"
           @mouseenter="show4 = true"
           @mouseleave="show4 = false"
           @click="showDetail(2)">
        <transition name="bottom-slide-up">
          <div class="bg-show"
               style="top: 87%"
               v-show="show4">
            <span v-show="show4">{{ $t('small-title-2') }}</span>
          </div>
        </transition>
        <transition name="bottom-slide-down">
          <div class="bg bg-show"
               style
               v-show="!show4"></div>
        </transition>
        <img src="../../assets/images/page1/img2.png" />
      </div>
      <div class="images-right">
        <div class="images-right--top">
          <div style="position: relative; display: inline-block"
               @mouseenter="show5 = true"
               @mouseleave="show5 = false"
               @click="showDetail(3)">
            <transition name="bottom-slide-up">
              <div class="bg-show"
                   style="bottom:4px;right:4px;"
                   v-show="show5">
                <span v-show="show5">{{ $t('small-title-3') }}</span>
              </div>
            </transition>
            <transition name="bottom-slide-down">
              <div class="bg bg-show"
                   style="bottom:4px;right:4px;"
                   v-show="!show5"></div>
            </transition>
            <img src="../../assets/images/page1/img3.png" />
          </div>
          <div style="position: relative; display: inline-block"
               @mouseenter="show6 = true"
               @mouseleave="show6 = false"
               @click="showDetail(4)">
            <transition name="bottom-slide-up">
              <div class="bg-show"
                   style="bottom:4px;right:4px;"
                   v-show="show6">
                <span v-show="show6">{{ $t('small-title-4') }}</span>
              </div>
            </transition>
            <transition name="bottom-slide-down">
              <div class="bg bg-show"
                   style="bottom:4px;right:4px;"
                   v-show="!show6"></div>
            </transition>
            <img src="../../assets/images/page1/img4.png" />
          </div>
        </div>
        <div class="images-right--bottom">
          <div style="position: relative; display: inline-block"
               @mouseenter="show7 = true"
               @mouseleave="show7 = false"
               @click="showDetail(7)">
            <transition name="bottom-slide-up">
              <div class="bg-show"
                   style="bottom:8px;right:4px;"
                   v-show="show7">
                <span v-show="show7">{{ $t('small-title-7') }}</span>
              </div>
            </transition>
            <transition name="bottom-slide-down">
              <div class="bg bg-show"
                   style="bottom:8px;right:4px;"
                   v-show="!show7"></div>
            </transition>
            <img src="../../assets/images/page1/img7.png" />
          </div>
          <div style="position: relative; display: inline-block"
               @mouseenter="show8 = true"
               @mouseleave="show8 = false"
               @click="showDetail(8)">
            <transition name="bottom-slide-up">
              <div class="bg-show"
                   style="bottom:8px;right:4px;"
                   v-show="show8">
                <span v-show="show8">{{ $t('small-title-8') }}</span>
              </div>
            </transition>
            <transition name="bottom-slide-down">
              <div class="bg bg-show"
                   style="bottom:8px;right:4px;"
                   v-show="!show8"></div>
            </transition>
            <img src="../../assets/images/page1/img8.png" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<i18n>
{
  "ch": {
    "title": "优托邦UTOPA项目介绍",
    "top-title": "【UTOPA HUB】",
    "top-content": "以满足都市日常生活、工作、聚会等社交体验为目的，创建生活服务及社交平台。",
    "bottom-title": "优托邦驿站",
    "bottom-content": "以满足日常生活服务和日常消费服务为基础，打造社区型社交服务平台",
    "small-title-1": "广州高德置地广场",
    "small-title-2": "杭州高德置地广场",
    "small-title-3": "UTOPA HUB（广州·奥体）",
    "small-title-4": "UTOPA HUB（广州·科学城）",
    "small-title-5": "UTOPA HUB（广州· CBD）",
    "small-title-6": "UTOPA HUB（株洲·神农太阳城）",
    "small-title-7": "UTOPA HUB（东莞·虎门）",
    "small-title-8": "UTOPA HUB（广州·长兴）",
    "content-1": "广州高德置地广场位于珠江新城CBD核心地段—花城广场公园两侧，从东到西横跨广州新中轴线，总建筑面积92万平方米。其中，商业部分逾20万平方米，由春、夏、秋、冬广场组成；写字楼约36万平方米，分别为A、B、C、D、E、F、G、H座等8座甲级写字楼；还有卓美亚酒店Jumeirah Hotel和卓美亚礼庭公寓Jumeirah Living，是集消费、商业及文化休闲于一体的大型商业项目。珠江新城规划为广州新中央商务区，也是中国三大国家级中央商务区之一。广州高德置地广场位于珠江新城核心区域，地理位置优越。项目横跨珠江新城花城广场，西起华夏路（地铁珠江新城站），东至花城大道（地铁猎德站），是地铁3号线、5号线及APM线的上盖物业，周边甲级写字楼、高级住宅区林立，各种城市文化配套及旅游设施齐全，形成广州新城市文化生活的核心区。",
    "content-2": "杭州高德置地广场总建筑面积约42万平方米，包括商业部分优托邦时光（UTOPA TIMES）、写字楼OFFICE A、B、C三区、私邸ICON RESIDENCES 、卓美亚酒店Jumeirah Hotel，还配套有美术馆和UTOPA CLUB等。项目由世界级设计公司SOM担纲总体设计，建筑立面体现“站立的西湖”理念，带来风靡世界的生活社交空间。杭州高德置地广场位于钱江新城CBD中心，是杭州政治、经济、文化新中心。市民中心、国际会议中心、杭州大剧院、城市阳台、波浪文化城等城市顶尖资源齐聚于此。周边交通畅达，地处地铁4号线和7号线上盖，邻近快速公交站。",
    "content-3": "UTOPA HUB（广州·奥体）总建筑面积为27万平方米，是以满足区域家庭生活为导向，集购物、生活配套、运动健康、亲子娱乐、家居艺术等于一体。项目内划分数个主题商业区，提供多样化的社交体验服务，主要主题区包括美居生活、童年时光、天为食、活力基地及娱乐体验专区的家年华。项目还拥有多项休闲设施，包括户外儿童游乐场，室内溜冰场，室外攀岩场馆，足球场及篮球场。UTOPA HUB（广州·奥体）位于广州市天河区东部奥体新城广园东快速路主干道，步行即可到达广州奥林匹克体育中心，是广州东部地区最大的社交体验空间。",
    "content-4": "UTOPA HUB（广州·科学城）总建筑面积约9万平方米，由A、B两座组合而成，是广州科学城内首个经营的商业项目。以社区生活社交空间为情景设计，集时尚零售、餐饮、儿童、娱乐、教育等于一体，满足消费者的日常生活所需。广州科学城是政府支持开发的科技园，是广州市东部发展战略的中心区域。UTOPA HUB（广州·科学城）位于区域的核心地带绿轴广场上，地处开泰大道，接连广深公路、广汕公路、环城高速公路及广州市地铁4号线及6号线，交通便利。",
    "content-5": "UTOPA HUB（广州· CBD）总建筑面积约为7万平方米，由东西两翼及第五季组合而成。围绕广州珠江新城CBD区域商业环境的个性化特色，着重构建生活、工作、聚会等社交空间，满足家庭、商务、生活等需求。该项目位于珠江新城CBD核心区内，公共交通设施便利。地处猎德地铁站上盖，可通过新光快速路、华南快速干线及猎德大桥等主要交通干道轻松到达。",
    "content-6": "UTOPA HUB（株洲·神农太阳城），是株洲的城市地标级项目。总建筑面积达28万平方米，由南北两区、文化休闲街及写字楼组成。其中呈现6大主题商业空间，集时尚零售、餐饮、儿童娱乐、教育、运动、娱乐休闲、家居、文化艺术及服务配套于一体。UTOPA HUB（株洲·神农太阳城）坐落株洲建设发展新区内，城市核心商圈—河西商圈核心位置，具有得天独厚的地理位置优势和美轮美奂的自然环境。",
    "content-7": "UTOPA HUB（东莞·虎门）总建筑面积约5万平方米，具有五层零售空间，集儿童、教育、零售、餐饮、娱乐休闲、运动等于一体。UTOPA HUB（东莞·虎门）位于广东省东莞市虎门中心城片区与中心城南片区交汇处——未来的虎门市中心，处于城市的主干道。交通便利，毗邻金捷路地铁站",
    "content-8": "UTOPA HUB（广州·长兴）总建筑面积约5万平方米，融合餐饮、时尚零售、休闲娱乐、生活服务4大商业功能，满足区域内人群的日常生活购物、休闲娱乐、健康运动、生活服务、社交聚会等消费需求。UTOPA HUB（广州·长兴）位于广州天河北部四大商圈交汇点，长湴村与元岗村交界处，邻近主要商业及住宅开发项目，接连广汕公路、华南快速路、天河客运站及广州市地铁3号线，交通便利。"
  },
  "zh": {
    "title": "優托邦UTOPA項目介紹",
    "top-title": "【UTOPA HUB】",
    "top-content": "以滿足都市日常生活、工作、聚會等社交體驗為目的，創建生活服務及社交平臺。",
    "bottom-title": "優托邦驛站",
    "bottom-content": "以滿足日常生活服務和日常消費服務為基礎，打造社區型社交服務平臺",
    "small-title-1": "廣州高德置地廣場",
    "small-title-2": "杭州高德置地廣場",
    "small-title-3": "UTOPA HUB（廣州·奧體）",
    "small-title-4": "UTOPA HUB（廣州·科學城）",
    "small-title-5": "UTOPA HUB（廣州· CBD）",
    "small-title-6": "UTOPA HUB（株洲·神農太陽城）",
    "small-title-7": "UTOPA HUB（東莞·虎門）",
    "small-title-8": "UTOPA HUB（廣州·長興）",
    "content-1": "廣州高德置地廣場位於珠江新城CBD核心地段—花城廣場公園兩側，從東到西橫跨廣州新中軸線，總建築面積92萬平方米。其中，商業部分逾20萬平方米，由春、夏、秋、冬廣場組成；寫字樓約36萬平方米，分別為A、B、C、D、E、F、G、H座等8座甲級寫字樓；還有卓美亞酒店Jumeirah Hotel和卓美亞禮庭公寓Jumeirah Living，是集消費、商業及文化休閒於一體的大型商業項目。珠江新城規劃為廣州新中央商務區，也是中國三大國家級中央商務區之一。廣州高德置地廣場位於珠江新城核心區域，地理位置優越。項目橫跨珠江新城花城廣場，西起華夏路（地鐵珠江新城站），東至花城大道（地鐵獵德站），是地鐵3號線、5號線及APM線的上蓋物業，周邊甲級寫字樓、高級住宅區林立，各種城市文化配套及旅遊設施齊全，形成廣州新城市文化生活的核心區。",
    "content-2": "杭州高德置地廣場總建築面積約42萬平方米，包括商業部分優托邦時光（UTOPA TIMES）、寫字樓OFFICE A、B、C三區、私邸ICON RESIDENCES 、卓美亞酒店Jumeirah Hotel，還配套有美術館和UTOPA CLUB等。項目由世界級設計公司SOM擔綱總體設計，建築立面體現“站立的西湖”理念，帶來風靡世界的生活社交空間。杭州高德置地廣場位於錢江新城CBD中心，是杭州政治、經濟、文化新中心。市民中心、國際會議中心、杭州大劇院、城市陽臺、波浪文化城等城市頂尖資源齊聚於此。周邊交通暢達，地處地鐵4號線和7號線上蓋，鄰近快速公交站。",
    "content-3": "UTOPA HUB（廣州·奧體）總建築面積為27萬平方米，是以滿足區域家庭生活為導向，集購物、生活配套、運動健康、親子娛樂、家居藝術等於一體。項目內劃分數個主題商業區，提供多樣化的社交體驗服務，主要主題區包括美居生活、童年時光、天為食、活力基地及娛樂體驗專區的家年華。項目還擁有多項休閒設施，包括戶外兒童遊樂場，室內溜冰場，室外攀岩場館，足球場及籃球場。UTOPA HUB（廣州·奧體）位於廣州市天河區東部奧體新城廣園東快速路主幹道，步行即可到達廣州奧林匹克體育中心，是廣州東部地區最大的社交體驗空間。",
    "content-4": "UTOPA HUB（廣州·科學城）總建築面積約9萬平方米，由A、B兩座組合而成，是廣州科學城內首個經營的商業項目。以社區生活社交空間為情景設計，集時尚零售、餐飲、兒童、娛樂、教育等於一體，滿足消費者的日常生活所需。廣州科學城是政府支援開發的科技園，是廣州市東部發展戰略的中心區域。UTOPA HUB（廣州·科學城）位於區域的核心地帶綠軸廣場上，地處開泰大道，接連廣深公路、廣汕公路、環城高速公路及廣州市地鐵4號線及6號線，交通便利。",
    "content-5": "UTOPA HUB（廣州· CBD）總建築面積約為7萬平方米，由東西兩翼及第五季組合而成。圍繞廣州珠江新城CBD區域商業環境的個性化特色，著重構建生活、工作、聚會等社交空間，滿足家庭、商務、生活等需求。該項目位於珠江新城CBD核心區內，公共交通設施便利。地處獵德地鐵站上蓋，可通過新光快速路、華南快速幹線及獵德大橋等主要交通幹道輕鬆到達。",
    "content-6": "UTOPA HUB（株洲·神農太陽城），是株洲的城市地標級項目。總建築面積達28萬平方米，由南北兩區、文化休閒街及寫字樓組成。其中呈現6大主題商業空間，集時尚零售、餐飲、兒童娛樂、教育、運動、娛樂休閒、家居、文化藝術及服務配套於一體。UTOPA HUB（株洲·神農太陽城）坐落株洲建設發展新區內，城市核心商圈—河西商圈核心位置，具有得天獨厚的地理位置優勢和美輪美奐的自然環境。",
    "content-7": "UTOPA HUB（東莞·虎門）總建築面積約5萬平方米，具有五層零售空間，集兒童、教育、零售、餐飲、娛樂休閒、運動等於一體。UTOPA HUB（東莞·虎門）位於廣東省東莞市虎門中心城片區與中心城南片區交匯處——未來的虎門市中心，處於城市的主幹道。交通便利，毗鄰金捷路地鐵站。",
    "content-8": "UTOPA HUB（廣州·長興）總建築面積約5萬平方米，融合餐飲、時尚零售、休閒娛樂、生活服務4大商業功能，滿足區域內人群的日常生活購物、休閒娛樂、健康運動、生活服務、社交聚會等消費需求。UTOPA HUB（廣州·長興）位於廣州天河北部四大商圈交匯點，長湴村與元崗村交界處，鄰近主要商業及住宅開發項目，接連廣汕公路、華南快速路、天河客運站及廣州市地鐵3號線，交通便利。"
  },
  "en": {
    "title": "UTOPA PROJECT INTRODUCTION",
    "top-title": "「UTOPA TIMES」",
    "top-content": "To create a CBD social platform for the purpose of satisfying social needs in life, work, and gatherings.",
    "bottom-title": "「UTOPA HUB」",
    "bottom-content": "To build a community-based business service platform for the purpose of satisfying customers’ daily needs and consumptions.",
    "small-title-1": "GT Land Plaza (Guangzhou)",
    "small-title-2": "GT Land Plaza (Hangzhou)",
    "small-title-3": "UTOPA HUB（Olympic Guangzhou）",
    "small-title-4": "UTOPA HUB（Science City Guangzhou）",
    "small-title-5": "UTOPA HUB（CBD Guangzhou）",
    "small-title-6": "UTOPA HUB（Zhuzhou·Shennong Sun City Zhuzhou）",
    "small-title-7": "UTOPA HUB（Dongguan Humen）",
    "small-title-8": "UTOPA HUB（Changxing Guangzhou）",
    "content-1": "GT Land Plaza is situated on both sides of Huacheng Square, the core area of the Zhujiang New Town CBD Guangzhou. It crosses the Guangzhou New Central Axis from east to west and has a total GFA of 920,000 square meters. GT Land Plaza is a large commercial complex integrating consumption, commerce and cultural leisure, it consists of commercial buildings which account for over 200,000 square meters, comprising the spring, summer, autumn and winter plaza; office buildings which account for approximately 360,000 square meters, including eight Grade A office buildings from Tower A to H; Jumeirah Guangzhou Hotel and Jumeirah Living Guangzhou Serviced Apartments. Zhujiang New Town is the new CBD of Guangzhou as well as one of the three national CBDs in China. Located at the prime area of Zhujiang New Town, GT Land Plaza spreads from west (Huaxia Road, Metro Zhujiang New Town Station) to east (Huacheng Road, Metro Liede Station). The project is also located above Metro Line 3, Line 5 and APM Line, surrounded by numerous Grade A office buildings and high-end residential blocks.",
    "content-2": "GT Land Plaza (Hangzhou) has a total GFA of approximately 420,000 square meters, comprising UTOPA TIMES, office buildings A, B, and C, ICON Private Residences, Jumeirah Hotel, art galleries and UTOPA CLUB etc. This project is designed by SOM, a world-class design company, with the design concept of the 'Standing West Lake' to create a world-famous social community. GT Land Plaza (Hangzhou) is located in the center of  Qianjiang New Town CBD, the new center for politics, economy and culture in Hangzhou, where the city's top resources, namely the Civic Center, the International Conference Center, the Hangzhou Grand Theatre, the City Balcony and the Wave Culture City gather around. GT Land Plaza (Hangzhou) enjoys a convenient location, it is situated right above subway line 4 and line 7 and is close to the rapid transit stations.",
    "content-3": "With a total GFA of 270,000 square meters, UTOPA HUB（Olympic Guangzhou） is catered for families in the region. It integrates shopping, living facilities, sports, parent-child entertainment and home art. The project is divided into several themed commercial districts to provide customers with diversified consumer goods and services, which include Magic Life, Energy Union and Carnival. It offers various leisure facilities, including an outdoor playground, indoor ice rink, outdoor rock climbing wall, football field and basketball court. UTOPA HUB（Olympic Guangzhou） is  located on the main road of Guangyuan East Expressway, the eastern part of Tianhe District. It is within walking distance of the Guangzhou Olympic Sports Center.",
    "content-4": "UTOPA HUB（Science City Guangzhou） has a total GFA of approximately 90,000 square meters and is composed of building A and B. As the first commercial project in Guangzhou Science City, it is designed to meet customers' basic needs and provide them with a social space which integrates fashion retail, catering, children, entertainment and education. Science City Guangzhou is a science and technology park supported by the Guangzhou government, it is also the center of Guangzhou's development in the eastern district. UTOPA HUB（Science City Guangzhou） is located at the Green Axis Square of Kaitai Avenue, the core area of the region, connecting Guangshen Highway, Guangshan Highway, Huancheng Expressway and Guangzhou Metro Line 4 and Line 6.",
    "content-5": "UTOPA HUB（CBD Guangzhou）is composed of the east and west wing and has a total GFA of approximately 70,000 square meters. It provides personalized social space for living, work and gatherings according to the commercial features of Zhujiang New Town CBD in Guangzhou. Located in the core area of Zhujiang New Town, the project is easily accessible by public transportation. It is above the Metro Station (Liede Station) and is connected to three main roads - Xinguang Expressway, South China Expressway and Liede Bridge.",
    "content-6": "UTOPA HUB（Shennong Sun City Zhuzhou） is a landmark project in Zhuzhou with a total GFA of 250,000 square meters, comprising south and north zones, culture & leisure street and office buildings. With six major commercial themes, the project offers customers with fashion retail, F&B, children's entertainment, education, sports, entertainment and leisure, home and cultural art and services. UTOPA HUB（Shennong Sun City Zhuzhou） is located in the Zhuzhou Construction and Development Zone, the core location of the city's core business district - the Hexi Commercial Area. It enjoys unique geographical advantages and a beautiful natural environment.",
    "content-7": "UTOPA HUB（Dongguan Humen） has a total GFA of approximately 47,000 square meters with a five-storey retail space, integrating kids, education, retail, F&B, sports, entertainment and leisure into a multi-dimensional cheerful experience space. UTOPA HUB（Dongguan Humen） is located at the intersection of the central and southern part of Humen - the future city center. The project connects with the city's main roads and is nearby the Jinjielu Metro Station.",
    "content-8": "UTOPA HUB（Changxing Guangzhou） has a total GFA of approximately 50,000 square meters. It integrates four commercial themes including F&B, fashion retail, leisure and entertainment as well as living to meet customers' needs on daily shopping, leisure and entertainment, sports, living and gatherings. UTOPA HUB（Changxing Guangzhou） is located at the intersection of four major trading areas in the northern part of Tianhe District in Guangzhou. Situated at the junction of Changban Village and Yuangang Village, it is nearby major commercial and residential development projects. It enjoys a convenient location as it connects with Guangshan Highway, South China Expressway, Tianhe Bus Terminal and Metro Line 3."
  }
}
</i18n>
<script>
import img1 from '../../assets/images/page1/1.png'
import img2 from '../../assets/images/page1/2.png'
import img3 from '../../assets/images/page1/3.png'
import img4 from '../../assets/images/page1/4.png'
import img5 from '../../assets/images/page1/5.png'
import img6 from '../../assets/images/page1/6.png'
import img7 from '../../assets/images/page1/7.png'
import img8 from '../../assets/images/page1/8.png'
export default {
  data () {
    return {
      show: false,
      left: false,
      show1: false,
      show2: false,
      show3: false,
      show4: false,
      show5: false,
      show6: false,
      show7: false,
      show8: false,
      detail: {
        img: '',
        title: '',
        content: ''
      }
    }
  },
  components: {
  },
  methods: {
    showDetail (index) {
      if (index === 1) {
        this.detail = {
          img: img1,
          title: this.$t('small-title-1'),
          content: this.$t('content-1')
        }
        this.left = false
      }
      if (index === 2) {
        this.detail = {
          img: img2,
          title: this.$t('small-title-2'),
          content: this.$t('content-2')
        }
        this.left = false
      }
      if (index === 3) {
        this.detail = {
          img: img3,
          title: this.$t('small-title-3'),
          content: this.$t('content-3')
        }
        this.left = true
      }
      if (index === 4) {
        this.detail = {
          img: img4,
          title: this.$t('small-title-4'),
          content: this.$t('content-4')
        }
        this.left = true
      }
      if (index === 5) {
        this.detail = {
          img: img5,
          title: this.$t('small-title-5'),
          content: this.$t('content-5')
        }
        this.left = false
      }
      if (index === 6) {
        this.detail = {
          img: img6,
          title: this.$t('small-title-6'),
          content: this.$t('content-6')
        }
        this.left = false
      }
      if (index === 7) {
        this.detail = {
          img: img7,
          title: this.$t('small-title-7'),
          content: this.$t('content-7')
        }
        this.left = true
      }
      if (index === 8) {
        this.detail = {
          img: img8,
          title: this.$t('small-title-8'),
          content: this.$t('content-8')
        }
        this.left = true
      }
      this.show = true
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  min-width: 1523px;
  max-width: 1523px;
}
.bg-show {
  opacity: 0.4;
  background: #000000;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 75%;
  line-height: 20px;
  padding: 10px;
  color: #fff;
  text-align: center;
  font-size: 12px;
}
.bg {
  top: 0 !important;
}

.bottom-slide-up-enter-active {
  animation: bottom-slide-up 0.5s ease-out;
}
.bottom-slide-up-leave-active {
  animation: bottom-slide-up 0.5s reverse ease-in;
}

.bottom-slide-down-enter-active {
  animation: bottom-slide-down 0.5s ease-out;
}
.bottom-slide-down-leave-active {
  animation: bottom-slide-down 0.5s reverse ease-in;
}

.left-slide-enter-active {
  animation-name: fade-in, left-slide;
  animation-duration: 0.5s;
  animation-delay: 0.3s;
  animation-fill-mode: both;
}
.left-slide-leave-active {
  animation: left-slide 0.5s reverse ease-in;
}
@keyframes left-slide {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(0);
  }
}

.right-slide-enter-active {
  animation-name: fade-in, right-slide;
  animation-duration: 0.5s;
  animation-delay: 0.3s;
  animation-fill-mode: both;
}
.right-slide-leave-active {
  animation: right-slide 0.5s reverse ease-in;
}
@keyframes right-slide {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0);
  }
}

@keyframes bottom-slide-up {
  0% {
    top: 0;
  }
  50% {
    top: 50%;
  }
  100% {
    top: 75%;
  }
}
@keyframes bottom-slide-down {
  0% {
    top: 75%;
  }
  50% {
    top: 50%;
  }
  100% {
    top: 0;
  }
}

.page1 {
  text-align: center;
  position: relative;
  top: 60px;
  .line {
    margin: 20px 0 30px 0;
  }
  .content {
    font-size: 14px;
    color: #999;
    margin-bottom: 46px;
    .item {
      margin-bottom: 15px;
    }
    .text {
      color: #ff4a2a;
      margin-right: 10px;
    }
  }
  .detail {
    height: 444px;
    width: 1244px;
    margin: 0 auto;
    display: flex;
    background: #404040;
    color: #ffffff;
    &-content {
      width: 620px;
      position: relative;
      &--title {
        font-size: 30px;
        color: #ffffff;
        position: absolute;
        top: 35px;
        left: 0;
        right: 0;
        text-align: center;
        line-height: 36px;
      }
      &--line {
        background: #58534f;
        width: 470px;
        height: 20px;
        margin-top: 60px;
        margin-bottom: 30px;
      }
      &--text {
        font-size: 16px;
        color: #ffffff;
        letter-spacing: 0;
        line-height: 32px;
        padding: 0 30px;
        clear: both;
        text-align: left;
        height: 320px;
        overflow-y: auto;
      }
      .right {
        float: right;
      }
      .left {
        float: left;
      }
    }
  }
  .images {
    height: 444px;
    display: flex;
    flex-direction: row;
    margin: 0 auto;
    width: 1244px;
    cursor: pointer;
    &-left {
      display: flex;
      flex-direction: column;
      &--top {
        flex: 1;
        margin-right: 4px;
        position: relative;
      }
      &--bottom {
        flex: 1;
        img {
          flex: 1;
          margin-right: 4px;
        }
      }
    }
    &-right {
      display: flex;
      flex-direction: column;
      margin-left: 4px;
      &--top {
        flex: 1;
        display: flex;
        img {
          flex: 1;
          margin-right: 4px;
        }
      }
      &--bottom {
        flex: 1;
        display: flex;
        img {
          flex: 1;
          margin-bottom: 4px;
          margin-right: 4px;
        }
      }
    }
  }
}
.title {
  font-size: 30px;
  color: #333333;
}
</style>
